import { Injectable } from "@angular/core";
import { ObtemDadosUsuario } from "src/app/domain/services/obtem-dados-usuario.service";

@Injectable({ providedIn: "root" })
export class CapturaInformacoesComputador {
	constructor(private obtemDadosService: ObtemDadosUsuario) {}

	public obtemSistemaOperacionalUsuario() {
		let OSNome = "";

		if (window.navigator.userAgent.indexOf("Windows NT 10.0") != -1) OSNome = "Windows 10";
		if (window.navigator.userAgent.indexOf("Windows NT 6.2") != -1) OSNome = "Windows 8";
		if (window.navigator.userAgent.indexOf("Windows NT 6.1") != -1) OSNome = "Windows 7";
		if (window.navigator.userAgent.indexOf("Windows NT 6.0") != -1) OSNome = "Windows Vista";
		if (window.navigator.userAgent.indexOf("Windows NT 5.1") != -1) OSNome = "Windows XP";
		if (window.navigator.userAgent.indexOf("Windows NT 5.0") != -1) OSNome = "Windows 2000";
		if (window.navigator.userAgent.indexOf("Mac") != -1) OSNome = "Mac/iOS";
		if (window.navigator.userAgent.indexOf("X11") != -1) OSNome = "UNIX";
		if (window.navigator.userAgent.indexOf("Linux") != -1) OSNome = "Linux";

		return OSNome;
	}

	public obtemNavegadorUsuario() {
		let browser,
			usrAg = navigator.userAgent;

		if (usrAg.indexOf("Chrome") > -1) {
			browser = "Google Chrome";
		} else if (usrAg.indexOf("Safari") > -1) {
			browser = "Apple Safari";
		} else if (usrAg.indexOf("Opera") > -1) {
			browser = "Opera";
		} else if (usrAg.indexOf("Firefox") > -1) {
			browser = "Mozilla Firefox";
		} else if (usrAg.indexOf("MSIE") > -1) {
			browser = "Microsoft Internet Explorer";
		}

		return browser;
	}

	public obtemIpUsuario(): Promise<string> {
		return this.obtemDadosService.obterEnderecoIP().then(res => {
			return res;
		});
	}
}
